import { colors } from 'themes/colors';

function CorrectedValue(props) {
  const { originValue, correctedValue, originClassName, correctedClassName, originStyle, correctedStyle } = props;

  const differenceValue = !!correctedValue && originValue?.toLowerCase() !== correctedValue?.toLowerCase();
  return (
    <>
      <div className={originClassName} style={{ ...originStyle, textDecoration: differenceValue && 'line-through' }}>
        {originValue}
      </div>
      {differenceValue && (
        <div
          className={correctedClassName || originClassName}
          style={{
            ...(correctedStyle || originStyle),
            color: colors.green,
          }}
        >
          {correctedValue}
        </div>
      )}
    </>
  );
}

export default CorrectedValue;
